import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSpeedSelectorIconLogic} from "./SpeedSelectorIcon.logic";
import {FontIcon} from "../../../components/common/FontIcon";
import {useIsDeviceDesktop} from "../../../services/device/device-info-hooks";


export const SpeedSelectorIcon: VoidFunctionComponent = () => {
  const {tempoIcon} = useSpeedSelectorIconLogic();
  const isDesktop = useIsDeviceDesktop();

  return (
    <div className="tempo-selector-button">
      <FontIcon icon={tempoIcon}/>
      {isDesktop ? <FontIcon icon={"icon-angle-down"} /> : null }
    </div>
  );
}
